import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
import classnames from 'classnames';
import { scrollClass } from './styles';
import fixedLength from './fixedLength';
import { isRTL } from '../config';

var ScrollBar =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(ScrollBar, _PureComponent);

  var _super = _createSuper2(ScrollBar);

  function ScrollBar(props) {
    var _this;

    _classCallCheck(this, ScrollBar);

    _this = _super.call(this, props);
    _this.handle = void 0;
    _this.cacheOffset = void 0;
    _this.mouseX = void 0;
    _this.mouseY = void 0;
    _this.state = {
      dragging: false
    };
    _this.bindHandle = _this.bindHandle.bind(_assertThisInitialized(_this));
    _this.handleBarClick = _this.handleBarClick.bind(_assertThisInitialized(_this));
    _this.handleBgClick = _this.handleBgClick.bind(_assertThisInitialized(_this));
    _this.handleMouseMove = _this.handleMouseMove.bind(_assertThisInitialized(_this));
    _this.unbindEvent = _this.unbindEvent.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(ScrollBar, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.unbindEvent();
    }
  }, {
    key: "toggleClassList",
    value: function toggleClassList(method) {
      if (this.handle && this.handle.parentNode && this.handle.parentNode.parentNode) {
        var _ref = this.handle.parentNode.parentNode,
            classList = _ref.classList;

        if (classList) {
          classList[method](scrollClass('dragging'));
        }
      }
    }
  }, {
    key: "bindHandle",
    value: function bindHandle(el) {
      this.handle = el;
    }
  }, {
    key: "bindEvent",
    value: function bindEvent() {
      document.addEventListener('mousemove', this.handleMouseMove);
      document.addEventListener('mouseup', this.unbindEvent);
    }
  }, {
    key: "unbindEvent",
    value: function unbindEvent() {
      this.setState({
        dragging: false
      });
      this.toggleClassList('remove');
      document.removeEventListener('mousemove', this.handleMouseMove);
      document.removeEventListener('mouseup', this.unbindEvent);
    }
  }, {
    key: "handleBarClick",
    value: function handleBarClick(event) {
      var offset = this.props.offset;
      this.cacheOffset = offset;
      this.setState({
        dragging: true
      });
      this.mouseX = event.clientX;
      this.mouseY = event.clientY;
      this.toggleClassList('add');
      this.bindEvent();
    }
  }, {
    key: "handleMouseMove",
    value: function handleMouseMove(event) {
      var x = event.clientX - this.mouseX;
      var y = event.clientY - this.mouseY;
      this.mouseX = event.clientX;
      this.mouseY = event.clientY;
      var _this$props = this.props,
          direction = _this$props.direction,
          length = _this$props.length,
          onScroll = _this$props.onScroll,
          barLength = _this$props.barLength;
      var value = direction === 'x' ? x : y;
      var newOffset;

      if (direction === 'x' && isRTL()) {
        newOffset = this.cacheOffset - value / (length - barLength);
      } else {
        newOffset = this.cacheOffset + value / (length - barLength);
      }

      if (newOffset < 0) newOffset = 0;
      if (newOffset > 1) newOffset = 1;
      if (newOffset === this.cacheOffset) return;
      this.cacheOffset = newOffset;
      onScroll(newOffset);
    }
  }, {
    key: "handleBgClick",
    value: function handleBgClick(event) {
      if (event.target === this.handle) return;
      var _this$props2 = this.props,
          direction = _this$props2.direction,
          length = _this$props2.length,
          scrollLength = _this$props2.scrollLength,
          offset = _this$props2.offset,
          onScroll = _this$props2.onScroll;
      var rect = this.handle.getBoundingClientRect();
      var newOffset = offset;
      var page = length / (scrollLength - length);
      var plus = isRTL() ? event.clientX < rect.left : event.clientX > rect.left;
      var add = isRTL() ? event.clientX > rect.left : event.clientX < rect.left;

      if (direction === 'x' && add || direction === 'y' && event.clientY < rect.top) {
        newOffset = offset - page;
        if (newOffset < 0) newOffset = 0;
      } else if (direction === 'x' && plus || direction === 'y' && event.clientY > rect.top) {
        newOffset = offset + page;
        if (newOffset > 1) newOffset = 1;
      }

      onScroll(newOffset);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          direction = _this$props3.direction,
          length = _this$props3.length,
          scrollLength = _this$props3.scrollLength,
          offset = _this$props3.offset,
          barLength = _this$props3.barLength,
          forceHeight = _this$props3.forceHeight;
      var dragging = this.state.dragging;
      var show = scrollLength > length;
      var rtl = isRTL();
      var className = classnames(scrollClass('bar', direction, show && 'show', dragging && 'dragging', !forceHeight && 'padding-y'), this.props.className);
      var value = (length - barLength) * offset;
      var x = rtl ? 'right' : 'left';
      var style = {};

      if (scrollLength > 0) {
        if (direction === 'x') {
          style.width = "".concat(length / scrollLength * 100, "%");
          style[x] = value;
        } else {
          style.height = "".concat(length / scrollLength * 100, "%");
          style.top = value;
        }
      }

      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: className,
          style: {
            height: forceHeight
          },
          onMouseDown: show ? this.handleBgClick : undefined
        },
        /*#__PURE__*/
        React.createElement("div", {
          className: scrollClass('handle'),
          onMouseDown: this.handleBarClick,
          ref: this.bindHandle,
          style: style
        }))
      );
    }
  }]);

  return ScrollBar;
}(PureComponent);

ScrollBar.defaultProps = {
  direction: 'y'
};
export default fixedLength(ScrollBar);